import { type AxiosInstance } from "axios";
import { getAttachedFileNameFromHeader } from "@/utils/utils";
import fileDownload from "js-file-download";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 指定された発注の宛先リストレポート（CSV）をダウンロードする。
 * @param apiClient - axios インスタンス
 * @param id - 発注ID
 * @returns レポートファイルをダウンロードする
 */
export const GetReportAPI = async (
  apiClient: AxiosInstance,
  id: number
): Promise<void> => {
  const url = `/dm/orders/${id}/report/`;

  try {
    const response = await apiClient.get<Blob>(url, {
      responseType: "blob",
    });
    const filename = getAttachedFileNameFromHeader(
      response,
      "dm-address-list-report.csv"
    );
    fileDownload(response.data, filename);
  } catch (error) {
    handleMutationError(error);
  }
};
